const contactDetails = [
  {
    label: "Address",
    value: "Ljubljanska cesta 40",
    icon: "ri-map-pin-2-fill",
  },
  {
    label: "City",
    value: "Bled",
    icon: "ri-building-2-fill",
  },
  {
    label: "Zip Code",
    value: "4260",
    icon: "ri-barcode-fill",
  },
  {
    label: "Country",
    value: "Slovenia",
    icon: "ri-global-fill",
  },
  {
    label: "Email",
    value: "info@mpibernikdoo.com",
    icon: "ri-mail-fill",
  },
  {
    label: "Phone Number",
    value: "+1 5803165425",
    icon: "ri-phone-fill",
  },
];

export default function ContactSection() {
  return (
    <footer id="contact" className="bg-gray-950 w-full">
      {/* Main Contact Block */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left: Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/f0693a50-811d-4e40-9c07-027eaa29169f.png"
                  alt="MPIBERNIK d.o.o. logo"
                  className="w-12 h-12 object-contain"
                />
              </div>
              <span className="text-white text-xl font-bold tracking-tight">
                MPIBERNIK d.o.o.
              </span>
            </div>
            <p className="text-gray-400 text-base leading-relaxed max-w-md mb-8">
              A team of expert iOS engineers crafting modern, secure, and high-performance applications for the Apple ecosystem. Proudly based in Slovenia, serving users worldwide.
            </p>
            <div className="flex items-center gap-2 text-emerald-400 text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-apple-fill text-base" />
              </div>
              <span className="font-medium">iOS Platform Specialists</span>
            </div>
          </div>

          {/* Right: Contact Details */}
          <div>
            <h3 className="text-white text-2xl font-bold mb-8">
              Get in Touch
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {contactDetails.map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-emerald-400 text-base`} />
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs uppercase tracking-wider font-medium mb-0.5">
                      {item.label}
                    </p>
                    <p className="text-white text-sm font-medium">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} MPIBERNIK d.o.o. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs">
            Bled, Slovenia — iOS Development Excellence
          </p>
        </div>
      </div>
    </footer>
  );
}
